module.exports = __webpack_public_path__ + "img/39.c3ca75f1.jpg";